import type { ReactNode } from "react";

type DataTableProps = {
  children: ReactNode;
  slim?: boolean;
  className?: string;
};

export function DataTable({ children, slim = false, className = "" }: DataTableProps) {
  return <div className={`table-wrap ${slim ? "slim-table" : ""} ${className}`.trim()}>{children}</div>;
}
